import { IAdminUserData } from '../../../../types/administration/userAdministration/IAdminUser';
import React, { useCallback } from 'react';
import { faUserCheck, faUserSlash } from '@fortawesome/pro-regular-svg-icons';
import { ePermissions } from '../../../../types/administration/userAdministration/ePermissions';
import { ButtonDropdown } from 'ui-toolkit';
import { RedGreenOptions } from '../../subComponents/RedGreenOptions';
import { useUpdateIdentityMutation } from '../../../../API/administration/IdentityAPI';
import { checkForMutationSuccess } from '../../../../API/checkForMutationSuccess';
import { EllipsisVerticalIcon, PencilSquareIcon, UserCircleIcon } from '@heroicons/react/24/outline';
import { AccessControlCheck } from 'components/accessControl/AccessControlCheck';

interface IdentityMenuDropdownProps {
  adminUser: IAdminUserData;
  setUpdateAdminUser: (adminUser: IAdminUserData) => void;
  setUpdateUserProfile: (adminUser: IAdminUserData) => void;
}

export const IdentityMenuDropdown: React.FC<IdentityMenuDropdownProps> = ({ adminUser, setUpdateAdminUser, setUpdateUserProfile }) => {
  const { fullName, identity } = adminUser;
  const [updateIdentity] = useUpdateIdentityMutation();

  const handleEnableClick = useCallback(async () => {
    const response = await updateIdentity({ id: identity.id, enabled: !identity.enabled });
    checkForMutationSuccess(response, `${fullName} is now ${!identity.enabled ? 'enabled' : 'disabled'}`);
  }, [fullName, identity, updateIdentity]);

  return (
    <AccessControlCheck allowedPermissions={[ePermissions.AuthIdentityEdit]}>
      <ButtonDropdown
        items={[
          {
            children: (
              <RedGreenOptions
                isEnabled={identity.enabled}
                activeIcon={faUserCheck}
                inactiveIcon={faUserSlash}
                type={'User'}
              />
            ),
            onClick: handleEnableClick,
          },
          {
            children: (
              <>
                <PencilSquareIcon className="mr-2 h-4 w-4" /> Edit User
              </>
            ),
            onClick: () => setUpdateAdminUser(adminUser),
          },
          {
            children: (
              <>
                <UserCircleIcon className="mr-2 h-4 w-4" /> Edit Profile
              </>
            ),
            onClick: () => setUpdateUserProfile(adminUser),
          },
        ]}
        intent="ghost"
        isInline
      >
        <EllipsisVerticalIcon className="h-4 w-4" />
      </ButtonDropdown>
    </AccessControlCheck>
  );
};
